import React from 'react'
import { Link } from 'gatsby'
import styled from '@emotion/styled'
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from 'react-icons/md'

import { PostItemType } from '~/types/post.types'
import { postItemMapper } from '~/utils/queryUtils'

import { ellipsis } from '~/styles/text'

interface Props {
  prevPost: PostItemType
  nextPost: PostItemType
}

const PostLink: React.VFC<Props> = ({ prevPost, nextPost }) => {
  return (
    <Wrapper>
      {nextPost && (
        <PrevLinkWrapper to={postItemMapper(nextPost).fields?.slug as string}>
          <MdOutlineKeyboardArrowLeft />
          <TextWrapper>
            <h5>이전 게시글</h5>
            <p>{postItemMapper(nextPost).frontmatter.title}</p>
          </TextWrapper>
        </PrevLinkWrapper>
      )}

      {prevPost && (
        <NextLinkWrapper to={postItemMapper(prevPost).fields?.slug as string}>
          <MdOutlineKeyboardArrowRight />
          <TextWrapper>
            <h5>다음 게시글</h5>
            <p>{postItemMapper(prevPost).frontmatter.title}</p>
          </TextWrapper>
        </NextLinkWrapper>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.section`
  height: 86px;
  margin: 30px 0;
  display: flex;
  position: relative;

  a {
    position: absolute;
    width: 45%;
    display: flex;
  }

  @media ${({ theme: { device } }) => device.mobile} {
    margin: 20px 0;
    height: max-content;
    display: flex;
    flex-direction: column;
    row-gap: 7px;

    a {
      position: static;
      width: 100%;
    }
  }
`

const TextWrapper = styled.div`
  width: calc(100% - 32px);
  font-family: GmarketSansMedium;
  color: ${({ theme: { colors } }) => colors.darkText};
  display: flex;
  flex-direction: column;
  align-items: center;

  h5,
  p {
    width: 100%;
  }

  h5 {
    ${({ theme: { typography } }) => typography.tag1}
    margin-bottom: 7px;
  }

  p {
    ${ellipsis}
    ${({ theme: { typography } }) => typography.body2}
  }
`

const PrevLinkWrapper = styled(Link)`
  padding: 20px 20px 20px 15px;
  border: 1px solid ${({ theme: { colors } }) => colors.text};

  display: flex;
  align-items: center;
  column-gap: 10px;

  border-radius: 10px;
  color: ${({ theme: { colors } }) => colors.deepText};

  @media ${({ theme: { device } }) => device.mobile} {
    padding: 15px 15px 15px 10px;
  }
`

const NextLinkWrapper = styled(PrevLinkWrapper)`
  right: 0;
  flex-direction: row-reverse;
  text-align: right;
`

export default PostLink
